import { Ability, AbilityClass } from "@casl/ability";
import { E_ACTIONS, E_SUBJECT } from "../enums/Permission.enum";

type Actions = E_ACTIONS;
type Subjects = E_SUBJECT;

export type AppAbility = Ability<[Actions, Subjects]>;
export const AppAbility = Ability as AbilityClass<AppAbility>;
